import { AfterViewInit, Component } from '@angular/core';
import { DatabaseService } from '../../providers/database.service';
import { AuthenticationService } from '../../providers/authentication.service';
import { FirebaseApp } from 'angularfire2';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router} from '@angular/router';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements AfterViewInit {

  public users: any;
  public devis: any;
  public faq: any;
  public emails: any;
  public recherche: any;
  public commandes: FormGroup;
  public sav: FormGroup;
  public search: FormGroup;
  public searching = false;
  constructor(public db: DatabaseService,
              public auth: AuthenticationService,
              private fb: FirebaseApp,
              public formBuilder: FormBuilder,
              private router: Router) {

    this.users = this.db.getAllUser();
    this.devis = this.db.getAllDevis();
    this.faq = this.db.getAllSav();
    this.emails = this.db.getAllEmail();

    this.sav = this.formBuilder.group({
      question: ['', Validators.required],
      reponse: ['', Validators.required]
    });

    this.search = this.formBuilder.group({
      type: ['nom', Validators.required],
      text: ['', Validators.required]
    });
  }

  ngAfterViewInit() {
  }

  deleteSav(uid) {
    this.db.deleteSav(uid);
  }

  logout() {
    this.auth.definedAuthData(false).then(() => {
      this.auth.logout().then(() => {
       console.log('tchiao');
      });
    });
  }

  showFiche(user) {
    this.router.navigate(['/fiche/' + user['uid']]);
  }

  addQuestion() {
    this.db.addSav(this.sav.value);
  }

  searchUser() {
    if (this.search.valid) {
      this.searching = true;
      this.db.search(this.search.value).valueChanges().forEach( recherche => {
        this.recherche = recherche;
      });
    } else {
      this.searching = false;
      this.users = this.db.getAllUser();
    }

  }

}



// WEBPACK FOOTER //
// /Users/Mustafa/Developpement/noxoe/src/components/admin/admin.component.ts